import { LLWildSymbolResult } from "integration/builders/result/ll-wild-bonus-result-builder";
import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class LLIsWildFortuneBlast extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();
        const record = gameplay.getCurrentRecord();

        const gatewayResult = record.getResultsOfType(LLWildSymbolResult)[0];
        return gatewayResult ? Exit.True : Exit.False;
    }
}
